import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';
import { jwtDecode } from 'jwt-decode';
import Modal from '../components/Modal';
import DiaClaseForm from '../components/DiaClaseForm';
import AttendanceForm from '../components/AttendanceForm';
import PublicacionForm from '../components/PublicacionForm';
import PublicacionCard from '../components/PublicacionCard';
import PlanDeClasesForm from '../components/PlanDeClasesForm';
import PlanDeClasesTable from '../components/PlanDeClasesTable';
import UnidadPlanTable from '../components/UnidadPlanTable';
import UnidadContentManagement from '../components/UnidadContentManagement';
import TaskDetailsModal from '../components/TaskDetailsModal';
import AssignTaskToStudentsModal from '../components/AssignTaskToStudentsModal';
import AssignEvaluationToStudentsModal from '../components/AssignEvaluationToStudentsModal';
import Swal from 'sweetalert2';
import { format, parseISO } from 'date-fns';
import { Tooltip as TooltipComponent } from 'react-tooltip';
import { es } from 'date-fns/locale';
import { Toaster, toast } from 'react-hot-toast';
import UnifiedAttendanceSection from '../components/UnifiedAttendanceSection';
import DocenteFinalGradesPage from './DocenteFinalGradesPage';
import FinalGradesSection from '../components/FinalGradesSection';



import ClassCalendar from './ClassCalendar';
import {
  ArrowLeft,
  Plus,
  Edit3,
  Trash2,
  Eye,
  Users,
  Calendar,
  Clock,
  MapPin,
  BookOpen,
  AlertCircle,
  DollarSign,
  MessageSquare,
  UserMinus,
  ClipboardCheck,
  CalendarCheck, // Añadir el nuevo icono
} from 'lucide-react';

const DocenteCatedraDetailPage = () => {
  const { id } = useParams();
  const [catedra, setCatedra] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // State for DiaClase and Asistencia
  const [diasClase, setDiasClase] = useState([]);
  const [isDiaClaseModalOpen, setIsDiaClaseModalOpen] = useState(false);
  const [editingDiaClase, setEditingDiaClase] = useState(null);
  const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false);
  const [selectedDiaClaseForAttendance, setSelectedDiaClaseForAttendance] = useState(null);
  const [studentPaymentStatuses, setStudentPaymentStatuses] = useState({});
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [annualAttendanceData, setAnnualAttendanceData] = useState([]);

  // State for Publicaciones (Tablón)
  const [publicaciones, setPublicaciones] = useState([]);
  const [isPublicacionModalOpen, setIsPublicacionModalOpen] = useState(false);
  const [editingPublicacion, setEditingPublicacion] = useState(null);
  const [publicationLoading, setPublicationLoading] = useState(false);
  const [scheduledClassDays, setScheduledClassDays] = useState([]);
  const [recordedClassDates, setRecordedClassDates] = useState([]);

  // State for Plan de Clases
  const [planesDeClase, setPlanesDeClase] = useState([]);
  const [isPlanDeClasesModalOpen, setIsPlanDeClasesModalOpen] = useState(false);
  const [editingPlanDeClases, setEditingPlanDeClases] = useState(null);
  const [selectedPlanDeClases, setSelectedPlanDeClases] = useState(null);
  const [viewingTask, setViewingTask] = useState(null);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedTaskForAssignment, setSelectedTaskForAssignment] = useState(null);
  const [isAssignEvaluationModalOpen, setIsAssignEvaluationModalOpen] = useState(false);
  const [selectedEvaluationForAssignment, setSelectedEvaluationForAssignment] = useState(null);

  const handleViewTask = (task) => {
    setViewingTask(task);
  };

  const handleAssignTask = (task) => {
    console.log("DocenteCatedraDetailPage - handleAssignTask called with task:", task);
    setSelectedTaskForAssignment(task);
    setIsAssignModalOpen(true);
    console.log("DocenteCatedraDetailPage - After state update: selectedTaskForAssignment=", task, "isAssignModalOpen=true");
  };

  const handleAssignEvaluation = (evaluation) => {
    console.log("DocenteCatedraDetailPage - handleAssignEvaluation called with evaluation:", evaluation);
    setSelectedEvaluationForAssignment(evaluation);
    setIsAssignEvaluationModalOpen(true);
    console.log("DocenteCatedraDetailPage - After state update: selectedEvaluationForAssignment=", evaluation, "isAssignEvaluationModalOpen=true");
  };


  // Stats para el dashboard
  const [stats, setStats] = useState({
    alumnosInscritos: 0
  });



  const fetchCatedra = useCallback(async () => {
    try {
      const response = await api.getDocenteCatedraDetalles(id);
      setCatedra(response.data);

      // Calcular estadísticas
      const alumnos = response.data.CatedraAlumno || [];

      setStats({
        alumnosInscritos: alumnos.length
      });


    } catch (err) {
      setError(err.response?.data?.message || 'Error al cargar los detalles de la cátedra.');
    } finally {
      setLoading(false);
    }
  }, [id]);

  const fetchDiasClase = useCallback(async () => {
    try {
      const response = await api.getDocenteDiasClase(id);
      setDiasClase(response.data);

      const dates = response.data.map(dia => new Date(dia.fecha).toISOString().split('T')[0]);
      setRecordedClassDates(dates);
    } catch (err) {
      console.error("Error al cargar los días de clase:", err);
      setError(err.response?.data?.message || 'Error al cargar los días de clase.');
    }
  }, [id]);

  const fetchAnnualAttendance = useCallback(async () => {
    try {
      const response = await api.getAnnualAttendance(id, currentYear);
      setAnnualAttendanceData(response.data);
    } catch (err) {
      console.error("Error al cargar la asistencia anual:", err);
      toast.error("Error al cargar la asistencia anual.");
    }
  }, [id, currentYear]);

  const handleUpdateDiaClaseTipo = async (diaClaseId, newTipoDia) => {
    try {
      await api.put(`/docente/catedra/${id}/diasClase/${diaClaseId}/tipo`, { tipoDia: newTipoDia });
      toast.success('Tipo de día actualizado exitosamente!');
      fetchDiasClase();
      fetchAnnualAttendance();
    } catch (error) {
      console.error('Error al actualizar el tipo de día de clase:', error);
      toast.error(error.response?.data?.error || 'Error al actualizar el tipo de día de clase.');
    }
  };

  const fetchPublicaciones = useCallback(async () => {
    try {
      const response = await api.getPublicaciones(id);
      setPublicaciones(response.data);
      console.log('[DEBUG - DocenteCatedraDetailPage] Publicaciones fetched:', response.data);
    } catch (err) {
      console.error("Error al cargar publicaciones:", err);
    }
  }, [id]);

  const fetchPlanesDeClase = useCallback(async () => {
    try {
      const response = await api.getDocentePlanesDeClase(id);
      setPlanesDeClase(response.data);
    } catch (err) {
      console.error("Error al cargar planes de clases:", err);
    }
  }, [id]);

  useEffect(() => {
    fetchCatedra();
    fetchDiasClase();
    fetchPublicaciones();
    fetchPlanesDeClase().then(() => {
      const lastViewedPlanId = sessionStorage.getItem('lastViewedPlanId');
      if (lastViewedPlanId) {
        // Esperar a que los planes de clase estén realmente cargados
        // Esto es un parche temporal, lo ideal sería un estado más robusto para planesDeClase
        setTimeout(() => {
          setPlanesDeClase(currentPlanes => {
            const planToRestore = currentPlanes.find(plan => String(plan.id) === lastViewedPlanId);
            if (planToRestore) {
              setSelectedPlanDeClases(planToRestore);
              sessionStorage.removeItem('lastViewedPlanId'); // Limpiar después de usar
            }
            return currentPlanes;
          });
        }, 100); // Pequeño retardo para asegurar que planesDeClase esté actualizado
      }
    });
  }, [fetchCatedra, fetchDiasClase, fetchPublicaciones, fetchPlanesDeClase]);

  useEffect(() => {
    // Si catedra o alumnosInscritos no están disponibles o están vacíos, no hacemos nada
    if (!catedra || !catedra.CatedraAlumno || catedra.CatedraAlumno.length === 0) {
      setStudentPaymentStatuses({});
      return;
    }

    const fetchPaymentStatuses = async () => {
      const currentCatedraId = catedra.id;
      const statuses = {};
      const fetchPromises = catedra.CatedraAlumno.map(async (inscripcion) => {
        const studentIdentifier = inscripcion.alumnoId || inscripcion.composerId;
        if (studentIdentifier) {
          try {
            const response = await api.getDocenteAlumnoPagos(studentIdentifier);
            if (response.data && Array.isArray(response.data.pagosConsolidados)) {
              response.data.pagosConsolidados.forEach(pagoCatedra => {
                if (pagoCatedra.catedraId === currentCatedraId) {
                  statuses[studentIdentifier] = pagoCatedra.estadoActual;
                }
              });
            } else {
              console.warn(`API getDocenteAlumnoPagos did not return expected structure for student ${studentIdentifier}:`, response.data);
            }
          } catch (error) {
            console.error(`Error fetching payment status for student ${studentIdentifier}:`, error);
            statuses[studentIdentifier] = 'ERROR_CARGA';
          }
        }
      });

      await Promise.all(fetchPromises);
      setStudentPaymentStatuses(statuses);
    };

    fetchPaymentStatuses();
  }, [catedra]);

  // Extraer días de la semana programados cuando la cátedra se carga o actualiza
  useEffect(() => {
    if (catedra?.CatedraDiaHorario) {
      const dayMap = {
        'Lunes': '1',
        'Martes': '2',
        'Miércoles': '3',
        'Jueves': '4',
        'Viernes': '5',
        'Sábado': '6',
        'Domingo': '7',
      };
      const days = catedra.CatedraDiaHorario.map(h => dayMap[h.dia_semana]).filter(Boolean);
      setScheduledClassDays(days);
    }
  }, [catedra]);

  useEffect(() => {
    if (selectedPlanDeClases && planesDeClase.length > 0) {
      const updatedSelectedPlan = planesDeClase.find(plan => plan.id === selectedPlanDeClases.id);
      if (updatedSelectedPlan) {
        setSelectedPlanDeClases(updatedSelectedPlan);
      }
    }
  }, [planesDeClase, selectedPlanDeClases]);

  useEffect(() => {
    fetchAnnualAttendance();
  }, [fetchAnnualAttendance]);

  const handleDiaClaseCreated = () => {
    fetchDiasClase();
    fetchAnnualAttendance();
    setIsDiaClaseModalOpen(false);
  };

  const handleDiaClaseUpdated = () => {
    fetchDiasClase();
    fetchAnnualAttendance();
    setIsDiaClaseModalOpen(false);
    setEditingDiaClase(null);
  };

  const handleDeleteDiaClase = async (diaClaseId) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: "¡Esta acción eliminará el día de clase y sus asistencias asociadas!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, ¡eliminarlo!',
      cancelButtonText: 'Cancelar'
    });
    if (result.isConfirmed) {
      try {
        await api.deleteDiaClase(catedra.id, diaClaseId);
        Swal.fire('¡Eliminado!', 'El día de clase ha sido eliminado.', 'success');
        fetchDiasClase();
        fetchAnnualAttendance();
      } catch (error) {
        Swal.fire('Error', error.response?.data?.error || 'Error al eliminar el día de clase.', 'error');
      }
    }
  };

  const openDiaClaseModal = (diaClase = null) => {
    setEditingDiaClase(diaClase);
    setIsDiaClaseModalOpen(true);
  };

  const openAttendanceModal = (diaClase) => {
    setSelectedDiaClaseForAttendance(diaClase);
    setIsAttendanceModalOpen(true);
  };

  const handleSaveAttendance = () => {
    fetchDiasClase();
    fetchAnnualAttendance();
    setIsAttendanceModalOpen(false);
    setSelectedDiaClaseForAttendance(null);
  };

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case 'AL DÍA': return 'bg-green-500/20 text-green-300 border-green-500/30';
      case 'EN MORA': return 'bg-red-500/20 text-red-300 border-red-500/30';
      case 'MATRÍCULA PENDIENTE': return 'bg-yellow-500/20 text-yellow-300 border-yellow-500/30';
      case 'MATRÍCULA PARCIALMENTE PAGADA': return 'bg-orange-500/20 text-orange-300 border-orange-500/30';
      case 'GRATUITO': return 'bg-blue-500/20 text-blue-300 border-blue-500/30';
      case 'ERROR_CARGA': return 'bg-gray-500/20 text-gray-300 border-gray-500/30';
      default: return 'bg-gray-500/20 text-gray-300 border-gray-500/30';
    }
  };

  const getPaymentStatusDisplay = (status) => {
    switch (status) {
      case 'AL DÍA': return 'Al Día';
      case 'EN MORA': return 'En Mora';
      case 'MATRÍCULA PENDIENTE': return 'Matrícula Pendiente';
      case 'MATRÍCULA PARCIALMENTE PAGADA': return 'Matrícula Parcial';
      case 'GRATUITO': return 'Gratuito';
      case 'ERROR_CARGA': return 'Error al Cargar';
      default: return 'Desconocido';
    }
  };

  const getTareaStatusBadge = (status, count, titles) => {
    let colorClass = 'bg-gray-500/20 text-gray-300 border-gray-500/30';
    let statusText = 'Desconocido';

    switch (status) {
      case 'ASIGNADA':
        colorClass = 'bg-orange-600/20 text-orange-300 border-orange-500/30';
        statusText = 'Pendiente';
        break;
      case 'ENTREGADA':
        colorClass = 'bg-blue-600/20 text-blue-300 border-blue-500/30';
        statusText = 'Entregada';
        break;
      case 'CALIFICADA':
        colorClass = 'bg-green-600/20 text-green-300 border-green-500/30';
        statusText = 'Calificada';
        break;
      case 'REVISION':
        colorClass = 'bg-purple-600/20 text-purple-300 border-purple-500/30';
        statusText = 'En Revisión';
        break;
      case 'PENDIENTE':
        colorClass = 'bg-yellow-600/20 text-yellow-300 border-yellow-500/30';
        statusText = 'Pendiente';
        break;
      default:
        break;
    }

    const tooltipHtml = `
      <div class="p-2 text-xs text-white bg-slate-700 rounded-md shadow-lg max-w-xs break-words">
        <p class="font-semibold mb-1">${statusText} (${count}):</p>
        <ul class="list-disc list-inside space-y-0.5">
          ${titles.map(title => `<li>${title}</li>`).join('')}
        </ul>
      </div>
    `;

    return (
      <span
        key={status}
        className={`relative px-2.5 py-1 rounded-full text-xs font-medium cursor-help ${colorClass}`}
        data-tooltip-id="task-tooltip"
        data-tooltip-html={tooltipHtml}
      >
        {statusText} ({count})
      </span>
    );
  };


  const handleDesinscribir = async (inscripcion) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: "Se eliminará la inscripción del alumno en esta cátedra.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, ¡desinscribir!',
      cancelButtonText: 'Cancelar'
    });
    if (result.isConfirmed) {
      try {
        const { alumnoId, composerId } = inscripcion;
        await api.desinscribirAlumnoForDocente(catedra.id, alumnoId, composerId);
        Swal.fire('¡Desinscrito!', 'El alumno ha sido desinscrito.', 'success');
        fetchCatedra();
      } catch (error) {
        Swal.fire('Error', error.response?.data?.error || 'Error al desinscribir.', 'error');
      }
    }
  };

  const handleCreatePublicacion = async (catedraId, data) => {
    setPublicationLoading(true);
    try {
      await api.createPublicacion(catedraId, data);
      Swal.fire('Publicación Creada', 'La publicación ha sido añadida al tablón.', 'success');
      setIsPublicacionModalOpen(false);
      fetchPublicaciones();
    } catch (error) {
      Swal.fire('Error', error.response?.data?.error || 'Error al crear la publicación.', 'error');
    } finally {
      setPublicationLoading(false);
    }
  };

  const handleEditPublicacion = async (publicacionId, data) => {
    setPublicationLoading(true);
    try {
      await api.updatePublicacion(id, publicacionId, data);
      Swal.fire('Publicación Actualizada', 'La publicación ha sido actualizada.', 'success');
      setIsPublicacionModalOpen(false);
      setEditingPublicacion(null);
      fetchPublicaciones();
    } catch (error) {
      Swal.fire('Error', error.response?.data?.error || 'Error al actualizar la publicación.', 'error');
    } finally {
      setPublicationLoading(false);
    }
  };

  const handleDeletePublicacion = async (publicacionId) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: "¡No podrás revertir esto! Se eliminará la publicación y todos sus comentarios.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, ¡eliminarla!',
      cancelButtonText: 'Cancelar'
    });
    if (result.isConfirmed) {
      console.log(`[Frontend] Intentando eliminar publicación. Catedra ID: ${id}, Publicacion ID: ${publicacionId}`);
      try {
        await api.deletePublicacion(id, publicacionId);
        Swal.fire('Publicación Eliminada', 'La publicación ha sido eliminada.', 'success');
        fetchPublicaciones();
      } catch (error) {
        Swal.fire('Error', error.response?.data?.error || 'Error al eliminar la publicación.', 'error');
      }
    }
  };

  const handleAddComment = async (publicacionId, commentData) => {
    try {
      const token = localStorage.getItem('docenteToken');
      let userId = null;
      let userType = null;

      if (token) {
        try {
          const decoded = jwtDecode(token);
          // Determinar si es docente o alumno del token (asumiendo que 'docenteId' o 'alumnoId' existen en el token)
          if (decoded.docenteId) {
            userId = decoded.docenteId;
            userType = 'docente';
          } else if (decoded.alumnoId) {
            userId = decoded.alumnoId;
            userType = 'alumno';
          }
        } catch (error) {
          console.error('Error decodificando el token al añadir comentario:', error);
        }
      }

      if (!userId || !userType) {
        toast.error('No se pudo identificar al usuario para añadir el comentario.');
        return;
      }

      const dataWithAuthor = { ...commentData, userId, userType };
      await api.createComentario(publicacionId, dataWithAuthor);
      fetchPublicaciones();
      toast.success('Comentario añadido exitosamente!');
    } catch (error) {
      console.error("Error al añadir comentario:", error);
      toast.error(error.response?.data?.error || 'Error al añadir el comentario.');
    }
  };

  const handleInteractToggle = async (publicacionId, hasUserInteracted) => {
    try {
      if (hasUserInteracted) {
        await api.removeInteraction(publicacionId);
        toast.info('Interacción eliminada.');
      } else {
        await api.addInteraction(publicacionId);
        toast.success('¡Has interactuado con la publicación!');
      }
      fetchPublicaciones();
    } catch (error) {
      console.error("Error al interactuar con la publicación:", error);
      toast.error('Error al interactuar con la publicación.');
    }
  };

  const handleDeleteComment = async (publicacionId, commentId) => {
    try {
      await api.deleteComentario(publicacionId, commentId);
      Swal.fire('Comentario Eliminado', 'El comentario ha sido eliminado.', 'success');
      fetchPublicaciones();
    } catch (error) {
      Swal.fire('Error', error.response?.data?.error || 'Error al eliminar el comentario.', 'error');
    }
  };

  const openPublicacionModal = (publicacion = null) => {
    setEditingPublicacion(publicacion);
    setIsPublicacionModalOpen(true);
  };

  const handlePlanDeClasesCreated = () => {
    fetchPlanesDeClase();
    setIsPlanDeClasesModalOpen(false);
  };

  const handlePlanDeClasesUpdated = () => {
    fetchPlanesDeClase();
    setIsPlanDeClasesModalOpen(false);
    setEditingPlanDeClases(null);
  };

  const openPlanDeClasesModal = (plan = null) => {
    setEditingPlanDeClases(plan);
    setIsPlanDeClasesModalOpen(true);
  };

  const handleDeletePlanDeClases = async (planId) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: "¡Esta acción eliminará el plan de clases y todas sus unidades asociadas!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, ¡eliminarlo!',
      cancelButtonText: 'Cancelar'
    });
    if (result.isConfirmed) {
      try {
        await api.deletePlanDeClases(planId);
        Swal.fire('¡Eliminado!', 'El plan de clases ha sido eliminado.', 'success');
        fetchPlanesDeClase();
      } catch (error) {
        Swal.fire('Error', error.response?.data?.error || 'Error al eliminar el plan de clases.', 'error');
      }
    }
  };

  const handleSelectPlanDeClases = (plan) => {
    setSelectedPlanDeClases(plan);
  };

  const handleBackToPlanes = () => {
    setSelectedPlanDeClases(null);
  };

  const handleCheckAttendanceInRange = async (alumno) => {
    const { value: formValues } = await Swal.fire({
      title: `Verificar Asistencia de ${alumno.nombre}`,
      html:
        `<p class="text-slate-400 text-sm mb-4">Selecciona un rango de fechas.</p>` +
        `<input id="swal-input-start" type="date" class="swal2-input">` +
        `<input id="swal-input-end" type="date" class="swal2-input">`,
      focusConfirm: false,
      confirmButtonText: 'Verificar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      preConfirm: () => {
        return [
          document.getElementById('swal-input-start').value,
          document.getElementById('swal-input-end').value
        ]
      }
    });

    if (formValues) {
      const [startDate, endDate] = formValues;
      if (!startDate || !endDate) {
        Swal.fire('Error', 'Debes seleccionar ambas fechas.', 'error');
        return;
      }

      const loadingSwal = Swal.fire({
        title: 'Calculando...',
        text: 'Por favor, espera.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const [asistenciasRes, diasClaseRes] = await Promise.all([
          api.get(`/docente/catedra/${id}/alumno/${alumno.id}/asistencias?startDate=${startDate}&endDate=${endDate}`),
          api.get(`/docente/catedra/${id}/diasClase?startDate=${startDate}&endDate=${endDate}`)
        ]);

        const clasesAsistidas = asistenciasRes.data.length;
        const clasesTotales = diasClaseRes.data.length;
        
        loadingSwal.close(); // Cerrar el swal de carga

        Swal.fire({
          title: 'Resultado de Asistencia',
          html: `El alumno asistió a <strong>${clasesAsistidas}</strong> de <strong>${clasesTotales}</strong> clases en el rango seleccionado.`,
          icon: 'success'
        });

      } catch (error) {
        loadingSwal.close(); // Cerrar el swal de carga
        console.error('Error verificando asistencia:', error);
        Swal.fire('Error', 'No se pudo verificar la asistencia. Inténtalo de nuevo.', 'error');
      }
    }
  };


  // Extraer el ID del docente del token para usarlo en PublicacionCard
  const [currentDocenteId, setCurrentDocenteId] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('docenteToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentDocenteId(decoded.docenteId);
        setUserRole(decoded.role);
      } catch (error) {
        console.error('Error decodificando el token del docente:', error);
        setCurrentDocenteId(null);
      }
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/30 to-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="w-20 h-20 border-4 border-purple-600/30 rounded-full animate-spin border-t-purple-500"></div>
            <div className="absolute inset-0 w-20 h-20 border-4 border-transparent rounded-full animate-ping border-t-purple-400"></div>
          </div>
          <p className="text-slate-300 mt-4 text-lg font-medium">Cargando cátedra...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/30 to-slate-950 flex items-center justify-center">
        <div className="text-center p-8">
          <AlertCircle size={64} className="text-red-500 mx-auto mb-4" />
          <p className="text-red-400 text-lg font-medium">{error}</p>
          <Link to="/docente/dashboard" className="inline-flex items-center gap-2 mt-4 text-purple-400 hover:text-purple-300 transition-colors">
            <ArrowLeft size={20} />
            Volver al Dashboard
          </Link>
        </div>
      </div>
    );
  }

  if (!catedra) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/30 to-slate-950 flex items-center justify-center">
        <div className="text-center p-8">
          <BookOpen size={64} className="text-slate-500 mx-auto mb-4" />
          <p className="text-slate-400 text-lg font-medium">Cátedra no encontrada</p>
          <Link to="/docente/dashboard" className="inline-flex items-center gap-2 mt-4 text-purple-400 hover:text-purple-300 transition-colors">
            <ArrowLeft size={20} />
            Volver al Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <Toaster />
      <TooltipComponent id="task-tooltip" effect="solid" html="true" className="z-50 !opacity-100" />
      <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/20 to-slate-950">
        {/* Header Navigation */}
        <div className="bg-slate-950/50 backdrop-blur-xl border-b border-slate-800/50">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <Link
              to="/docente/dashboard"
              className="inline-flex items-center gap-2 text-slate-300 hover:text-white transition-all duration-300 group"
            >
              <div className="p-2 rounded-lg bg-white/5 group-hover:bg-white/10 transition-colors">
                <ArrowLeft size={20} />
              </div>
              <span className="font-medium">Volver al Dashboard</span>
            </Link>
          </div>
        </div>

        <div className="max-w-7xl mx-auto p-6 space-y-8">
          {/* Sección de Tablón */}
          <div className="bg-slate-900/50 backdrop-blur-xl rounded-2xl border border-slate-700/50 overflow-hidden">
            <div className="bg-gradient-to-r from-slate-800/50 to-slate-800/30 p-6 border-b border-slate-700/50">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-green-600/20 rounded-lg">
                    <MessageSquare className="text-green-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Tablón de la Cátedra</h3>
                    <p className="text-slate-400">{publicaciones?.length || 0} publicaciones</p>
                  </div>
                </div>
                <button
                  onClick={() => openPublicacionModal()}
                  className="group inline-flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-medium rounded-xl transition-all duration-300 shadow-lg shadow-green-900/25 hover:shadow-xl hover:shadow-green-900/40 hover:scale-105"
                >
                  <Plus size={20} className="group-hover:rotate-90 transition-transform duration-300" />
                  <span>Crear Publicación</span>
                </button>
              </div>
            </div>

            <div className="p-6">
              {(publicaciones?.length === 0) ? (
                <div className="text-center py-12">
                  <div className="w-20 h-20 mx-auto mb-4 bg-slate-800/50 rounded-full flex items-center justify-center">
                    <MessageSquare className="text-slate-500" size={32} />
                  </div>
                  <p className="text-slate-400 text-lg font-medium">No hay publicaciones</p>
                  <p className="text-slate-500 text-sm mt-1">Comparte anuncios e información importante con tus estudiantes</p>
                </div>
              ) : (
                (currentDocenteId !== null && currentDocenteId !== undefined) ? (
                  <div className="space-y-6">
                    {publicaciones.map(publicacion => (
                      <PublicacionCard
                        key={publicacion.id}
                        publicacion={publicacion}
                        onAddComment={handleAddComment}
                        onDeletePublication={handleDeletePublicacion}
                        onDeleteComment={handleDeleteComment}
                        onEditPublication={() => openPublicacionModal(publicacion)}
                        onInteractToggle={handleInteractToggle}
                        userType="docente"
                        userId={currentDocenteId}
                        docenteId={currentDocenteId}
                        catedraNombre={catedra.nombre}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 border-4 border-purple-600/30 rounded-full animate-spin border-t-purple-500 mx-auto"></div>
                    <p className="text-slate-400 mt-4">Cargando publicaciones...</p>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Header de la Cátedra */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-slate-900/80 via-purple-900/40 to-slate-900/80 backdrop-blur-xl border border-slate-700/50">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 via-pink-600/5 to-purple-600/10"></div>
            <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-purple-500/20 to-transparent rounded-full blur-3xl"></div>

            <div className="relative z-10 p-8">
              <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
                <div className="space-y-4">
                  <h1 className="text-4xl lg:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-purple-200 to-white">
                    {catedra.nombre}
                  </h1>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600/20 text-purple-200 rounded-full text-sm font-medium border border-purple-500/30">
                      <BookOpen size={16} />
                      {catedra.institucion}
                    </span>
                    <span className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600/20 text-blue-200 rounded-full text-sm font-medium border border-blue-500/30">
                      <Calendar size={16} />
                      {catedra.anio}
                    </span>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-1 gap-4">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                    <div className="flex items-center gap-2 mb-2">
                      <Users className="text-pink-400" size={20} />
                      <span className="text-xs text-slate-400 font-medium">ALUMNOS</span>
                    </div>
                    <div className="text-2xl font-bold text-white">{stats.alumnosInscritos}</div>
                  </div>
                </div>
              </div>

              {/* Info adicional de la cátedra */}
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-slate-800/30 backdrop-blur-sm rounded-xl p-4 border border-slate-700/50">
                  <div className="flex items-center gap-2 text-slate-300 mb-2">
                    <Clock size={18} />
                    <span className="font-medium">Turno</span>
                  </div>
                  <span className="text-white font-semibold text-lg">{catedra.turno}</span>
                </div>
                <div className="bg-slate-800/30 backdrop-blur-sm rounded-xl p-4 border border-slate-700/50">
                  <div className="flex items-center gap-2 text-slate-300 mb-2">
                    <Calendar size={18} />
                    <span className="font-medium">Horarios</span>
                  </div>
                  <div className="space-y-1">
                    {catedra.CatedraDiaHorario && catedra.CatedraDiaHorario.length > 0 ? (
                      catedra.CatedraDiaHorario.map((horario, index) => (
                        <div key={index} className="text-sm">
                          <span className="text-white font-semibold">{horario.dia_semana}:</span>
                          <span className="text-slate-300 ml-1">{horario.hora_inicio} - {horario.hora_fin}</span>
                        </div>
                      ))
                    ) : (
                      <span className="text-slate-400">No definido</span>
                    )}
                  </div>
                </div>
                <div className="bg-slate-800/30 backdrop-blur-sm rounded-xl p-4 border border-slate-700/50">
                  <div className="flex items-center gap-2 text-slate-300 mb-2">
                    <MapPin size={18} />
                    <span className="font-medium">Aula</span>
                  </div>
                  <span className="text-white font-semibold text-lg">{catedra.aula}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Sección de Planes de Clase */}
          {selectedPlanDeClases ? (
            <UnidadPlanTable
              plan={selectedPlanDeClases}
              onBackToPlanes={handleBackToPlanes}
              fetchPlanesDeClase={fetchPlanesDeClase}
              onViewTask={handleViewTask}
              onAssignTask={handleAssignTask}
              onAssignEvaluation={handleAssignEvaluation}
            />
          ) : (
            <PlanDeClasesTable
              planesDeClase={planesDeClase}
              onEdit={openPlanDeClasesModal}
              onDelete={handleDeletePlanDeClases}
              onSelect={handleSelectPlanDeClases}
              onCreate={() => openPlanDeClasesModal()}
            />
          )}

          {/* Aqui estaba la Seccion Dias de Clase Asistencia Anual */}
          {/* Sección Unificada de Asistencia */}
          <UnifiedAttendanceSection
            diasClase={diasClase}
            annualAttendanceData={annualAttendanceData}
            currentYear={currentYear}
            setCurrentYear={setCurrentYear}
            onOpenDiaClaseModal={openDiaClaseModal}
            onEditDiaClase={(diaClase) => openDiaClaseModal(diaClase)}
            onDeleteDiaClase={handleDeleteDiaClase}
            onOpenAttendanceModal={openAttendanceModal}
            onUpdateDiaClaseTipo={handleUpdateDiaClaseTipo}
            scheduledClassDays={scheduledClassDays}
            recordedClassDates={recordedClassDates}
          />

          {/* Sección de Calificaciones Finales */}
          <div className="bg-slate-900/50 backdrop-blur-xl rounded-2xl border border-slate-700/50 overflow-hidden">
            <div className="bg-gradient-to-r from-slate-800/50 to-slate-800/30 p-6 border-b border-slate-700/50">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-purple-600/20 rounded-lg">
                    <ClipboardCheck className="text-purple-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Calificaciones Finales</h3>
                    <p className="text-slate-400">Gestiona las configuraciones y resultados de calificaciones finales</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-6">
              <FinalGradesSection />
            </div>
          </div>

          {/* Sección de Alumnos */}
          <div className="bg-slate-900/50 backdrop-blur-xl rounded-2xl border border-slate-700/50 overflow-hidden">
            <div className="bg-gradient-to-r from-slate-800/50 to-slate-800/30 p-6 border-b border-slate-700/50">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-pink-600/20 rounded-lg">
                  <Users className="text-pink-400" size={24} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white">Alumnos Inscritos</h3>
                  <p className="text-slate-400">{catedra.CatedraAlumno?.length || 0} estudiantes</p>
                </div>
              </div>
            </div>

            <div className="p-6">
              {catedra.CatedraAlumno.length === 0 ? (
                <div className="text-center py-12">
                  <div className="w-20 h-20 mx-auto mb-4 bg-slate-800/50 rounded-full flex items-center justify-center">
                    <Users className="text-slate-500" size={32} />
                  </div>
                  <p className="text-slate-400 text-lg font-medium">No hay alumnos inscritos</p>
                  <p className="text-slate-500 text-sm mt-1">Los estudiantes aparecerán aquí cuando se inscriban</p>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full">
                    <thead>
                      <tr className="border-b border-slate-700/50">
                        <th className="text-left py-4 px-4 text-slate-300 font-semibold">Estudiante</th>
                        <th className="text-left py-4 px-4 text-slate-300 font-semibold">Email</th>
                        <th className="text-left py-4 px-4 text-slate-300 font-semibold">Tareas</th>
                        <th className="text-left py-4 px-4 text-slate-300 font-semibold">Evaluaciones</th>
                        <th className="text-left py-4 px-4 text-slate-300 font-semibold">Estado de Pagos</th>
                        <th className="text-left py-4 px-4 text-slate-300 font-semibold">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {catedra?.CatedraAlumno.map((inscripcion) => {
                        const nombre = inscripcion.Alumno
                          ? `${inscripcion.Alumno.nombre} ${inscripcion.Alumno.apellido}`
                          : inscripcion.Composer
                            ? `${inscripcion.Composer.student_first_name} ${inscripcion.Composer.student_last_name} (Contrib.)`
                            : 'Nombre Desconocido';
                        const email = inscripcion.Alumno
                          ? inscripcion.Alumno.email
                          : inscripcion.Composer
                            ? inscripcion.Composer.email
                            : 'N/A';
                        const studentIdentifier = inscripcion.alumnoId || inscripcion.composerId;
                        const paymentStatus = studentPaymentStatuses[studentIdentifier];

                        return (
                          <tr key={inscripcion.id} className="border-b border-slate-800/50 hover:bg-slate-800/20 transition-colors">
                            <td className="py-4 px-4">
                              <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                                  {nombre.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2)}
                                </div>
                                <div>
                                  <div className="font-medium text-white">{nombre}</div>
                                </div>
                              </div>
                            </td>
                            <td className="py-4 px-4 text-slate-300">{email}</td>
                            <td className="py-4 px-4 text-slate-300">
                              <div className="flex flex-wrap gap-2">
                                {(() => {
                                  const alumnoTareas = (inscripcion.Alumno?.TareaAsignacion || inscripcion.Composer?.TareaAsignacion || []);
                                  if (alumnoTareas.length === 0) {
                                    return <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-gray-600/20 text-gray-300 border border-gray-500/30">No hay tareas asignadas</span>;
                                  }

                                  const tareasAgrupadas = alumnoTareas.reduce((acc, tarea) => {
                                    if (tarea.TareaMaestra) {
                                      const status = tarea.estado;
                                      if (!acc[status]) {
                                        acc[status] = { count: 0, titles: [] };
                                      }
                                      acc[status].count++;
                                      acc[status].titles.push(tarea.TareaMaestra.titulo);
                                    }
                                    return acc;
                                  }, {});

                                  return Object.entries(tareasAgrupadas).map(([status, data]) => (
                                    getTareaStatusBadge(status, data.count, data.titles)
                                  ));
                                })()}
                              </div>
                            </td>
                            <td className="py-4 px-4 text-slate-300">
                              <div className="flex flex-wrap gap-2">
                                {(() => {
                                  const alumnoEvaluaciones = inscripcion.Alumno?.EvaluacionAsignacion || [];
                                  if (alumnoEvaluaciones.length === 0) {
                                    return <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-gray-600/20 text-gray-300 border border-gray-500/30">No hay evaluaciones asignadas</span>;
                                  }

                                  return (
                                    <div className="flex flex-col gap-2">
                                      {alumnoEvaluaciones.map(evaluacionAsignacion => {
                                        const estado = evaluacionAsignacion.estado;
                                        let colorClass = '';
                                        let statusText = '';
                                        let actionButton = null;

                                        switch (estado) {
                                          case 'PENDIENTE':
                                            colorClass = 'bg-yellow-600/20 text-yellow-300 border-yellow-500/30';
                                            statusText = 'Pendiente';
                                            break;
                                          case 'REALIZADA':
                                            colorClass = 'bg-blue-600/20 text-blue-300 border-blue-500/30';
                                            statusText = 'Realizada';
                                            break;
                                          case 'CALIFICADA':
                                            colorClass = 'bg-green-600/20 text-green-300 border-green-500/30';
                                            statusText = 'Calificada';
                                            break;
                                          case 'VENCIDA':
                                            colorClass = 'bg-red-600/20 text-red-300 border-red-500/30';
                                            statusText = 'Vencida';
                                            break;
                                          default:
                                            colorClass = 'bg-gray-600/20 text-gray-300 border-gray-500/30';
                                            statusText = 'Desconocido';
                                        }

                                        return (
                                          <div key={evaluacionAsignacion.id} className="flex items-center">
                                            <span
                                              className={`px-2.5 py-1 rounded-full text-xs font-medium ${colorClass}`}
                                            >
                                              {evaluacionAsignacion.Evaluacion?.titulo || 'Evaluación'} ({statusText})
                                            </span>
                                            {(estado === 'REALIZADA' || estado === 'CALIFICADA') && (
                                              <Link
                                                to={`/docente/catedra/${catedra.id}/alumnos/${studentIdentifier}/evaluaciones/${evaluacionAsignacion.evaluacionId}/results`}
                                                className="ml-2 p-1 bg-purple-600/20 text-purple-300 hover:bg-purple-600/30 hover:text-purple-200 rounded-lg transition-all duration-200 border border-purple-500/30"
                                                title="Ver Resultados"
                                              >
                                                <Eye size={16} />
                                              </Link>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  );
                                })()}
                              </div>
                            </td>
                            <td className="py-4 px-4">
                              <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-sm border ${getPaymentStatusColor(paymentStatus)}`}>
                                <DollarSign size={14} />
                                {getPaymentStatusDisplay(paymentStatus)}
                              </span>
                            </td>
                            <td className="py-4 px-4">
                              <div className="flex items-center gap-2">
                                <Link
                                  to={`/docente/catedra/${catedra.id}/alumno/${inscripcion.alumnoId || inscripcion.composerId}`}
                                  className="p-2 bg-indigo-600/20 text-indigo-300 hover:bg-indigo-600/30 hover:text-indigo-200 rounded-lg transition-all duration-200 border border-indigo-500/30"
                                  title="Ver Detalles"
                                >
                                  <Eye size={16} />
                                </Link>
                                {/* El enlace a la página de calificaciones finales del alumno se elimina para integrar la funcionalidad en esta vista */}
                                <button
                                  onClick={() => {
                                    const studentInfo = {
                                      id: inscripcion.alumnoId || inscripcion.composerId,
                                      nombre: inscripcion.Alumno ? `${inscripcion.Alumno.nombre} ${inscripcion.Alumno.apellido}` : `${inscripcion.Composer.student_first_name} ${inscripcion.Composer.student_last_name}`
                                    };
                                    handleCheckAttendanceInRange(studentInfo);
                                  }}
                                  className="p-2 bg-cyan-600/20 text-cyan-300 hover:bg-cyan-600/30 hover:text-cyan-200 rounded-lg transition-all duration-200 border border-cyan-500/30"
                                  title="Verificar Asistencia en Rango"
                                >
                                  <CalendarCheck size={16} />
                                </button>
                                <button
                                  onClick={() => handleDesinscribir(inscripcion)}
                                  className="p-2 bg-red-600/20 text-red-300 hover:bg-red-600/30 hover:text-red-200 rounded-lg transition-all duration-200 border border-red-500/30"
                                  title="Desinscribir"
                                >
                                  <UserMinus size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modales */}
      <Modal
        isOpen={isDiaClaseModalOpen}
        onClose={() => setIsDiaClaseModalOpen(false)}
        title={editingDiaClase ? "Editar Día de Clase" : "Crear Nuevo Día de Clase"}
        showSubmitButton={false}
        showCancelButton={false}
      >
        <DiaClaseForm
          catedraId={catedra?.id}
          onDiaClaseCreated={handleDiaClaseCreated}
          onDiaClaseUpdated={handleDiaClaseUpdated}
          onCancel={() => setIsDiaClaseModalOpen(false)}
          initialData={editingDiaClase}
          isEditMode={!!editingDiaClase}
          scheduledDays={catedra?.CatedraDiaHorario?.map(h => h.dia_semana)}
        />
      </Modal>

      {selectedDiaClaseForAttendance && (
        <Modal
          isOpen={isAttendanceModalOpen}
          onClose={() => setIsAttendanceModalOpen(false)}
          title={`Asistencia para ${(() => {
            const date = new Date(selectedDiaClaseForAttendance.fecha);
            const userTimezoneOffset = date.getTimezoneOffset() * 60000;
            const correctedDate = new Date(date.getTime() + userTimezoneOffset);
            return format(correctedDate, 'dd/MM/yyyy');
          })()} (${selectedDiaClaseForAttendance.dia_semana})`}
          showSubmitButton={false}
          showCancelButton={false}
        >
          <AttendanceForm
            catedraId={catedra?.id}
            diaClaseId={selectedDiaClaseForAttendance.id}
            alumnos={catedra.CatedraAlumno}
            onSave={handleSaveAttendance}
            onCancel={() => setIsAttendanceModalOpen(false)}
          />
        </Modal>
      )}

      <Modal
        isOpen={isPublicacionModalOpen}
        onClose={() => setIsPublicacionModalOpen(false)}
        title={editingPublicacion ? "Editar Publicación" : "Crear Nueva Publicación"}
        showSubmitButton={false}
        showCancelButton={false}
      >
        <PublicacionForm
          catedraId={catedra?.id}
          onSubmit={editingPublicacion ? handleEditPublicacion : handleCreatePublicacion}
          initialData={editingPublicacion || {}}
          isEditMode={!!editingPublicacion}
          loading={publicationLoading}
          onCancel={() => setIsPublicacionModalOpen(false)}
          userRole={userRole}
          isTablonCreation={true}
        />
      </Modal>

      <Modal
        isOpen={isPlanDeClasesModalOpen}
        onClose={() => setIsPlanDeClasesModalOpen(false)}
        title={editingPlanDeClases ? "Editar Plan de Clases" : "Crear Nuevo Plan de Clases"}
        showSubmitButton={false}
        showCancelButton={false}
      >
        <PlanDeClasesForm
          catedraId={catedra?.id}
          onPlanCreated={handlePlanDeClasesCreated}
          onPlanUpdated={handlePlanDeClasesUpdated}
          onCancel={() => setIsPlanDeClasesModalOpen(false)}
          initialData={editingPlanDeClases}
          isEditMode={!!editingPlanDeClases}
        />
      </Modal>

      <TaskDetailsModal
        isOpen={!!viewingTask}
        onClose={() => setViewingTask(null)}
        task={viewingTask}
      />

      {selectedTaskForAssignment && (
        <AssignTaskToStudentsModal
          isOpen={isAssignModalOpen}
          onClose={() => setIsAssignModalOpen(false)}
          task={selectedTaskForAssignment}
          students={catedra?.CatedraAlumno?.map(ca => ca.Alumno || ca.Composer) || []}
          catedraId={catedra?.id}
          onTaskAssigned={() => {
            console.log('Tarea asignada, refrescando planes de clase...');
            fetchPlanesDeClase(); // Esto recargará todas las unidades y tareas
          }}
        />
      )}

      {selectedEvaluationForAssignment && (
        <AssignEvaluationToStudentsModal
          isOpen={isAssignEvaluationModalOpen}
          onClose={() => setIsAssignEvaluationModalOpen(false)}
          evaluation={selectedEvaluationForAssignment}
          students={catedra?.CatedraAlumno?.map(ca => ca.Alumno || ca.Composer) || []}
          catedraId={catedra?.id}
          onEvaluationAssigned={() => {
            console.log('Evaluación asignada, refrescando contenido de unidad...');
            fetchPlanesDeClase(); // Podría ser necesario un fetchContent más específico si solo afecta una unidad
          }}
        />
      )}
    </>
  );
};

export default DocenteCatedraDetailPage;